'use strict'

import 'lazysizes'
import 'picturefill'
import 'picturefill/dist/plugins/intrinsic-dimension/pf.intrinsic.min.js'
import { mounted, getParam, extractionrAreaCodeData } from './utilities/index'
import { trackPageView } from './modules/trackEvent/trackPageView'
import { initDataSet } from './modules/dataset'
import player from './modules/player'
import lineup from './modules/lineup'
import castInfo from './modules/castInfo'
import FreeArea from './modules/FreeArea'
import tabSwitch from './modules/tabSwitch'
import About from './modules/about'

// bambuserのjs読み込み
const bambuserSet = () => {
  const liveStationEl = document.querySelector('.js-liveStation')
  const cmsRegion = liveStationEl.dataset.cmsRegion

  if (!window.initBambuserLiveShopping) {
    window.initBambuserLiveShopping = item => {
      window.initBambuserLiveShopping.queue.push(item)
    }
    window.initBambuserLiveShopping.queue = []
    const scriptNode = document.createElement('script')
    scriptNode['src'] = `https://lcx-embed.bambuser.com/uniqlo-${cmsRegion === 'vn'
      ? 'vn'
      : 'global'
      }/embed.js`
    document.body.appendChild(scriptNode)
  }
  const channelscriptNode = document.createElement('script')
  channelscriptNode['src'] = `https://lcx-widgets.bambuser.com/embed.js`
  document.body.appendChild(channelscriptNode)
}

const productsFunc = async () => {
  try {
    const products = await import(
      /* webpackChunkName: "products" */
      './modules/products'
    )
    new products.default()
  } catch (error) {
    /* eslint no-console: 0 */
    console.log(error)
  }
}

const fixedAnchorFunc = async () => {
  try {
    const fixedAncherElem = document.querySelector('.js-ls-fixedAnchor')
    if (!fixedAncherElem) return

    const { fixedAnchor } = await import(
      /* webpackChunkName: "fixedAnchor" */
      './modules/fixedAnchor'
    )
    fixedAnchor(fixedAncherElem)
  } catch (error) {
    /* eslint no-console: 0 */
    console.log(error)
  }
}

const trackFunc = async () => {
  try {
    const el = document.querySelectorAll('.js-trackEvent')
    if (!el.length) {
      return
    }
    const { attachEventTrack } = await import(
      /* webpackChunkName: "trackReading" */ './modules/trackEvent/track'
    )
    attachEventTrack(el)
  } catch (error) {
    /* eslint no-console: 0 */
    console.log(error)
  }
}

const trackReadingFunc = async () => {
  try {
    const el = document.querySelectorAll('.js-trackEventReading')
    if (!el.length) {
      return
    }
    const { attachEventTrackReading } = await import(
      /* webpackChunkName: "trackReading" */ './modules/trackEvent/trackReading'
    )
    attachEventTrackReading(el)
  } catch (error) {
    /* eslint no-console: 0 */
    console.log(error)
  }
}

const trackScrollFunc = async () => {
  try {
    const el = document.querySelector('.js-trackEventScroll')
    if (!el) {
      return
    }
    const { trackEventScroll } = await import(
      /* webpackChunkName: "trackEventScroll" */ './modules/trackEvent/trackEventScroll'
    )
    trackEventScroll(el)
  } catch (error) {
    /* eslint no-console: 0 */
    console.log(error)
  }
}

const autoAspectSet = async () => {
  try {
    const items = document.querySelectorAll('[data-auto-aspect-ratio]')
    if (!items.length) return

    const { autoAspect } = await import(
      /* webpackChunkName: "autoAspectSet" */ '@modules/autoAspectSet'
    )
    autoAspect(items)
  } catch (error) {
    /* eslint no-console: 0 */
    console.log(error)
  }
}

const lsModalSet = async () => {
  try {
    const items = document.querySelectorAll('.js-lsModalOpen')
    if (!items.length) return

    const lsModal = await import(
      /* webpackChunkName: "lsModalSet" */ '@modules/lsModalSet'
    )
    new lsModal.default(items)
  } catch (error) {
    /* eslint no-console: 0 */
    console.log(error)
  }
}

const smoothScrollSet = async () => {
  try {
    const items = document.querySelectorAll('.js-smoothScroll')
    if (!items.length) return

    const { smoothScroll } = await import(
      /* webpackChunkName: "smoothScroll" */ '@modules/smoothScroll'
    )
    smoothScroll(items)
  } catch (error) {
    /* eslint no-console: 0 */
    console.log(error)
  }
}

mounted(async () => {

  const pagetype = getParam('type')
  const url = new URL(window.location.href);
  const params = url.searchParams;

  // まずjsonCMSのデータをすべて取得してグローバル変数に投入
  await initDataSet()
  // area:01のjson取得
  const pickupExistence = extractionrAreaCodeData(
    '01',
    window.LIVESTATION.MAINCONTENT
  )[0]
  // area:01のlineupに1があったらpickupありの処理
  if (pickupExistence.lineup == "1") {
    document.body.dataset.pickupExistence = "yes"
    new tabSwitch(url, pagetype, params)
  } else {
    params.delete('type')
    params.delete('autoplay')
    history.replaceState({}, '', url);
  }


  // GA設定
  trackPageView()
  trackFunc()
  trackReadingFunc()
  trackScrollFunc()

  bambuserSet()
  // area:01のlineupに1があったらpickupありの処理
  if (pickupExistence.lineup == "1") {
    new player(pagetype)
    new lineup()
    new castInfo()
    new FreeArea()

    productsFunc()
    fixedAnchorFunc()
    autoAspectSet()
    smoothScrollSet()
  }
  new About()
  lsModalSet()
})
